"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var appnexusUtils_1 = require("../utils/appnexusUtils");
var owa_analytics_1 = require("owa-analytics");
var owa_strings_1 = require("owa-strings");
var owa_mail_ads_shared_1 = require("owa-mail-ads-shared");
require("external-fan-prebid");
var pbjs;
var apn;
var marketCountryCode;
var isOneClick;
var loadPrebidNativeAdsDataPoint;
function fetchPrebidNativeAds(messageAdType, adMarket, triggerEvent) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var targetDivId, appNexusInvCode;
        return tslib_1.__generator(this, function (_a) {
            loadPrebidNativeAdsDataPoint = new owa_analytics_1.PerformanceDatapoint('LoadPrebidNativeAds');
            // Prebid only supports OneClick at this time
            isOneClick = true;
            marketCountryCode = owa_mail_ads_shared_1.getMarketCountryCode(adMarket);
            targetDivId = 'OwaContainer';
            appNexusInvCode = appnexusUtils_1.contructAppNexusPageGroup(isOneClick);
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    pbjs = window.pbjs;
                    pbjs.que.push(function () {
                        var customConfigObject = {
                            buckets: [
                                {
                                    precision: 0,
                                    min: 0,
                                    max: 2000,
                                    increment: 5,
                                },
                            ],
                        };
                        //set custom config object
                        pbjs.setPriceGranularity(customConfigObject);
                        var adUnits = [
                            {
                                code: targetDivId,
                                sizes: [[320, 50]],
                                bids: [
                                    {
                                        bidder: 'audienceNetwork',
                                        params: {
                                            placementId: '1962231667378978_2050883985180412',
                                            format: 'native',
                                            pageurl: 'outlook.live.com',
                                        },
                                    },
                                ],
                            },
                        ];
                        pbjs.addAdUnits(adUnits);
                        pbjs.requestBids({
                            bidsBackHandler: function (bidResponses) {
                                // Get FAN bid
                                var bidResponsesAdUnit = pbjs.getBidResponsesForAdUnitCode(targetDivId);
                                pbjs.que.push(function () {
                                    var scriptElement = window.document.createElement('script');
                                    scriptElement.type = 'text/javascript';
                                    scriptElement.src = 'https://acdn.adnxs.com/ast/static/0.10.0/ast.js';
                                    scriptElement.onload = function () {
                                        pbjs.setTargetingForAst();
                                        apn = window.apntag;
                                        apn.anq.push(function () {
                                            apn.setPageOpts({
                                                member: 280,
                                                user: {
                                                    dnt: owa_mail_ads_shared_1.getToptOutCookie(),
                                                    externalUid: owa_mail_ads_shared_1.getMuidCookie(),
                                                },
                                            });
                                            apn.defineTag({
                                                member: 280,
                                                invCode: appNexusInvCode,
                                                extInvCode: marketCountryCode,
                                                sizes: [[1, 1]],
                                                targetId: targetDivId,
                                                allowedFormats: ['native'],
                                                allowSmallerSizes: false,
                                                trafficSourceCode: 'pg:' + appNexusInvCode,
                                            });
                                            apn.onEvent('adLoaded', targetDivId, function (rawAdObject) {
                                                var result = [];
                                                var prebidAd;
                                                if (rawAdObject &&
                                                    rawAdObject.creativeId == 73775939 &&
                                                    bidResponsesAdUnit &&
                                                    bidResponsesAdUnit.bids &&
                                                    bidResponsesAdUnit.bids[0] &&
                                                    bidResponsesAdUnit.bids[0].adId) {
                                                    apn.fireImpressionTrackers(rawAdObject);
                                                    prebidAd = GeneratePrebidFanAd(messageAdType, adMarket, triggerEvent, bidResponsesAdUnit.bids[0].adId);
                                                    loadPrebidNativeAdsDataPoint.addCustomData({
                                                        messageAdType: messageAdType,
                                                        userMarket: adMarket,
                                                        originalMessageAdType: null,
                                                        refreshEvent: triggerEvent,
                                                        loadReason: 'FanWinAst',
                                                    });
                                                    result.push(prebidAd);
                                                    loadPrebidNativeAdsDataPoint.end();
                                                    resolve(result);
                                                }
                                                else {
                                                    var appNexusMessageAdType = messageAdType == "PrebidOneClickOIO" /* PrebidOneClickOIO */
                                                        ? "AppNexusOneClickOIO" /* AppNexusOneClickOIO */
                                                        : "AppNexusOneClick" /* AppNexusOneClick */;
                                                    prebidAd = appnexusUtils_1.GenerateAppNexusAd(rawAdObject, appNexusMessageAdType, adMarket, triggerEvent, isOneClick);
                                                    if (prebidAd) {
                                                        // Use apn's own fire Impression tracker method to fire the impression tracker required by AppNexus
                                                        apn.fireImpressionTrackers(rawAdObject);
                                                        loadPrebidNativeAdsDataPoint.addCustomData({
                                                            messageAdType: appNexusMessageAdType,
                                                            userMarket: adMarket,
                                                            originalMessageAdType: null,
                                                            refreshEvent: triggerEvent,
                                                            loadReason: 'AstWinFan',
                                                        });
                                                        result.push(prebidAd);
                                                        loadPrebidNativeAdsDataPoint.end();
                                                        resolve(result);
                                                    }
                                                }
                                            });
                                            apn.onEvent('adRequestFailure', targetDivId, function (rawAdError) {
                                                var logClientError = new Error('AppNexusAdRequestFailure: ' +
                                                    owa_strings_1.format('AppNexus hits the error. Error code is {0} and Error Message is {1}', rawAdError.code, rawAdError.errMessage));
                                                loadPrebidNativeAdsDataPoint.addCustomData({
                                                    messageAdType: messageAdType,
                                                    userMarket: adMarket,
                                                    originalMessageAdType: null,
                                                    refreshEvent: triggerEvent,
                                                });
                                                loadPrebidNativeAdsDataPoint.endWithError(owa_analytics_1.DatapointStatus.ClientError, logClientError);
                                                resolve(null);
                                            });
                                            apn.onEvent('adNoBid', targetDivId, function (rawAdObject) {
                                                if (bidResponsesAdUnit &&
                                                    bidResponsesAdUnit.bids &&
                                                    bidResponsesAdUnit.bids[0] &&
                                                    bidResponsesAdUnit.bids[0].adId) {
                                                    var result = [];
                                                    var prebidAd = GeneratePrebidFanAd(messageAdType, adMarket, triggerEvent, bidResponsesAdUnit.bids[0].adId);
                                                    loadPrebidNativeAdsDataPoint.addCustomData({
                                                        messageAdType: messageAdType,
                                                        userMarket: adMarket,
                                                        originalMessageAdType: null,
                                                        refreshEvent: triggerEvent,
                                                        loadReason: 'FanFillAstNoBid',
                                                    });
                                                    result.push(prebidAd);
                                                    loadPrebidNativeAdsDataPoint.end();
                                                    resolve(result);
                                                }
                                                else {
                                                    var logClientError = new Error('AppNexusAdNoBid: ' +
                                                        owa_strings_1.format('AppNexus No Bid. Tag id is {0} and auction id is {1}', rawAdObject.tagId, rawAdObject.auctionId));
                                                    loadPrebidNativeAdsDataPoint.addCustomData({
                                                        messageAdType: messageAdType,
                                                        userMarket: adMarket,
                                                        originalMessageAdType: null,
                                                        refreshEvent: triggerEvent,
                                                    });
                                                    loadPrebidNativeAdsDataPoint.endWithError(owa_analytics_1.DatapointStatus.ClientError, logClientError);
                                                    resolve(null);
                                                }
                                            });
                                            apn.loadTags();
                                            apn.showTag(targetDivId);
                                        });
                                    };
                                    scriptElement.onerror = function () {
                                        var logClientError = new Error('AppNexusApnNotLoaded');
                                        loadPrebidNativeAdsDataPoint.addCustomData({
                                            messageAdType: messageAdType,
                                            userMarket: adMarket,
                                            originalMessageAdType: null,
                                            refreshEvent: triggerEvent,
                                        });
                                        loadPrebidNativeAdsDataPoint.endWithError(owa_analytics_1.DatapointStatus.ClientError, logClientError);
                                        resolve(null);
                                    };
                                    window.document.head.appendChild(scriptElement);
                                });
                            },
                        });
                    });
                })];
        });
    });
}
exports.default = fetchPrebidNativeAds;
function GeneratePrebidFanAd(messageAdType, adMarket, triggerEvent, adFanBidId) {
    return {
        adSender: '',
        adSubject: '',
        adPreviewTexts: '',
        adChoiceUrl: '',
        adType: messageAdType,
        adMarket: adMarket,
        adRefreshEvent: triggerEvent,
        adFanBidId: adFanBidId,
        isRead: false,
    };
}
//# sourceMappingURL=fetchPrebidNativeAds.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-messagead-orchestration/lib/services/fetchPrebidNativeAds.js
// module id = 6012
// module chunks = 67